import { render, staticRenderFns } from "./SpinnerWheelLabel.vue?vue&type=template&id=62337e64&scoped=true"
import script from "./SpinnerWheelLabel.vue?vue&type=script&lang=js"
export * from "./SpinnerWheelLabel.vue?vue&type=script&lang=js"
import style0 from "./SpinnerWheelLabel.vue?vue&type=style&index=0&id=62337e64&prod&lang=scss&scoped=true"
import style1 from "./SpinnerWheelLabel.vue?vue&type=style&index=1&id=62337e64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62337e64",
  null
  
)

export default component.exports